import hyperHTML from 'hyperhtml';

const placeholder = state => hyperHTML.wire(state, ':placeholder')`
  <div class="e-dataselect__label e-dataselect__label-placeholder">${state.placeholder}</div>
`;

const label = state => hyperHTML.wire(state, ':label')`
  <div class="e-dataselect__label">${state.selected.label}</div>
`;

export default (renderer, state, eventHandlers) => {
  return renderer`
    <div class="e-select" onclick=${eventHandlers.open}>
      ${state.selected ? label(state) : placeholder(state) }
    </div>
  `;
};
